module.exports = __webpack_public_path__ + "img/中通金融.e3d90be4.png";